import { $Q } from "graditify-utils";
import SwiperModule from "swiper";
import { Navigation } from "swiper/modules";

export function initSwiper() {
  const swiper = new SwiperModule(".swiper-container", {
    modules: [Navigation],
    direction: "horizontal",
    loop: false,
    navigation: {
      nextEl: ".swiper-button--next",
      prevEl: ".swiper-button--prev",
    },
  });

  swiper.on("slideChange", (e) => {
    const nextCta = $Q(".swiper-button--next");
    const prevCta = $Q(".swiper-button--prev");

    if (!e.allowSlidePrev) {
      prevCta.disabled = "true";
    }

    if (!e.allowSlideNext) {
      nextCta.disabled = "true";
    }
  });
}
